<app-checkout-popup #checkoutPopup></app-checkout-popup>

<div class="page-container">
  <!--<app-checkout-popup #checkoutPopup></app-checkout-popup>-->

  <div class="appointment-summary-page column">
    <div class="row gap-20 justify-space-between w-100" style="padding: 20px 0px;">
      <div>
        <button class="cancel-btn custom-btn" (click)="CancelAppointment()" *ngIf="!appointment.IsSeries">Cancel</button>
        <button class="cancel-btn custom-btn" (click)="CancelAppointmentSeries()" *ngIf="appointment.IsSeries">Cancel Series</button>
      </div>
      <div *ngIf="!appointment.IsEmployeeMeeting" class="row gap-20">
        <button class="custom-btn" (click)="AdminCheckout()">Admin Checkout</button>
        <button class="custom-btn" (click)="AudiologistCheckout()">Audio Checkout</button>
      </div>
    </div>
    <!---->
    <div class="appointment-summary column gap-30">
      <div class="header">
        <h1>appointment Summary</h1>
      </div>
      <!---->
      <div class="column gap-30" style=" padding: 0 20px 20px;">
        <div class="header-title" *ngIf="!appointment.IsEmployeeMeeting">
          <h2>{{appointment.PatientTitle}} {{appointment.PatientName}}</h2>
        </div>
        <div class="header-title" *ngIf="appointment.IsEmployeeMeeting">
          <h2>{{appointment.CreatedBy}}</h2>
        </div>
        <!---->
        <hr />
        <div class="column gap-20">
          <!-- Apointment Details:  Staff - Audiologist -->
          <div class="row justify-space-between gap-20" *ngIf="!appointment.IsEmployeeMeeting">
            <div class="row gap-20">
              <div class="title align-center">
                <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.2116 21.2143C19.5518 19.157 18.2558 17.3624 16.5106 16.0892C14.7651 14.8161 12.6605 14.13 10.5001 14.13C8.33971 14.13 6.23511 14.8161 4.48974 16.0892C2.74439 17.3624 1.44842 19.157 0.788696 21.2143H20.2116Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M10.5 14.1429C14.1729 14.1429 17.1504 11.1654 17.1504 7.49253C17.1504 3.81963 14.1729 0.842163 10.5 0.842163C6.82709 0.842163 3.84961 3.81963 3.84961 7.49253C3.84961 11.1654 6.82709 14.1429 10.5 14.1429Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12.6717 10.0657C12.6717 10.0657 12.1199 11.1514 10.5002 11.1514C8.88042 11.1514 8.32861 10.0657 8.32861 10.0657" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M17.0299 6.22635C17.015 6.22644 17.0002 6.22649 16.9855 6.22649C15.0523 6.22649 13.3168 5.38076 12.1286 4.03914C10.9404 5.3808 9.20486 6.22654 7.27177 6.22654C6.14923 6.22654 5.0933 5.94134 4.17249 5.43946C5.03762 2.77131 7.54347 0.842163 10.4999 0.842163C13.7398 0.842163 16.4386 3.15903 17.0299 6.22635Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h2>Scheduled by:</h2>
              </div>
              <div class="form-group">
                <app-custom-dropdown [options]="staffList"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="appointment.CreateByAgentID"
                                     [optionsText]="'FullName'"
                                     [optionsValue]="'ID'">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="row gap-20">
              <div class="title align-center">
                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.34891 5.01203C1.84197 3.60328 3.78204 0.785767 7.59774 0.785767C12.3674 0.785767 15.1048 4.83957 14.2692 8.63455C13.5447 11.925 11.4919 13.0721 10.5863 13.857C9.26336 15.0036 9.26373 15.9391 8.78388 17.4523C8.50635 18.3278 7.54195 19.576 6.19857 19.7298C5.22499 19.8412 4.05237 19.378 2.7979 17.7814" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M21.7143 15.3774C21.7143 18.601 19.101 21.2141 15.8775 21.2141" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M19.0164 15.2673C19.0164 17.0008 17.6111 18.4061 15.8775 18.4061" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M16.4063 14.3942C16.4063 15.2001 15.753 15.8534 14.9471 15.8534" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  in
                  <path d="M4.18684 7.06463C4.47251 6.3592 5.49152 4.98192 7.28228 5.11634C9.07304 5.25076 10.6106 7.06463 9.97669 8.74765C9.34276 10.4306 8.50493 9.90964 7.74281 11.0419C6.9807 12.1742 7.26537 14.4459 5.56929 14.7852C4.51273 14.9965 3.95782 14.3902 3.95782 14.3902" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h2>Audiologist:</h2>
              </div>
              <div class="form-group">
                <app-custom-dropdown [options]="audioligsts"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="appointment.AllocatedUserID"
                                     [optionsText]="'FullName'"
                                     [optionsValue]="'ID'"
                                     tabindex="1">
                </app-custom-dropdown>
              </div>
            </div>
          </div>
          <!---->
          <!-- Apointment Details:  Date - Time-->
          <div class="row justify-space-between">
            <div class="row gap-20">
              <div class="title align-center">
                <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.6428 2.85706C2.26392 2.85706 1.90056 3.00757 1.63265 3.27547C1.36474 3.54338 1.21423 3.90674 1.21423 4.28563V17.8571C1.21423 18.2359 1.36474 18.5993 1.63265 18.8672C1.90056 19.1351 2.26392 19.2856 2.6428 19.2856H18.3571C18.7359 19.2856 19.0994 19.1351 19.3672 18.8672C19.6351 18.5993 19.7857 18.2359 19.7857 17.8571V4.28563C19.7857 3.90674 19.6351 3.54338 19.3672 3.27547C19.0994 3.00757 18.7359 2.85706 18.3571 2.85706H15.4999" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M1.21423 7.85706H19.7857" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.5 0.714233V4.99995" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.5 0.714233V4.99995" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M5.5 2.85706H12.6429" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h2 *ngIf="!appointment.IsEmployeeMeeting">Appointment:</h2>
                <h2 *ngIf="appointment.IsEmployeeMeeting">{{appointment.ServiceName}}:</h2>
              </div>
              <div class="form-group">
                <app-calendar-dropdown [(selectedDate)]="appointment.StartDate"></app-calendar-dropdown>
              </div>
            </div>
          </div>
          <hr />
          <!-- Apointment Details:  Branch - Location -->
          <div class="row justify-space-between gap-20" *ngIf="!appointment.IsEmployeeMeeting">
            <div class="row gap-20">
              <div class="title align-center">
                <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.5714 7.8572C15.5714 12.5715 8.49999 18.0715 8.49999 18.0715C8.49999 18.0715 1.42856 12.5715 1.42856 7.8572C1.42856 4.00562 4.64842 0.785767 8.49999 0.785767C12.3516 0.785767 15.5714 4.00562 15.5714 7.8572Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.5 10.2143C9.80181 10.2143 10.8571 9.15896 10.8571 7.85714C10.8571 6.55532 9.80181 5.5 8.5 5.5C7.19818 5.5 6.14285 6.55532 6.14285 7.85714C6.14285 9.15896 7.19818 10.2143 8.5 10.2143Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h2>Branch:</h2>
              </div>
              <div class="form-group">
                <p>{{appointment.BranchName}}</p>
              </div>
            </div>
            <div class="row gap-20" *ngIf="!appointment.IsEmployeeMeeting">
              <div class="title align-center">
                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.5 10.9077C21.5015 10.6942 21.4584 10.4826 21.3737 10.2866C21.2889 10.0906 21.1643 9.91443 21.0077 9.76923L11.5 1L1.99234 9.76923C1.83577 9.91443 1.71113 10.0906 1.62637 10.2866C1.54162 10.4826 1.49859 10.6942 1.50004 10.9077V19.4615C1.50004 19.8695 1.66212 20.2609 1.95064 20.5494C2.23916 20.8378 2.63047 21 3.03849 21H19.9615C20.3695 21 20.7609 20.8378 21.0493 20.5494C21.338 20.2609 21.5 19.8695 21.5 19.4615V10.9077Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.5 20.9999V14.8461" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h2>Testing Facility:</h2>
              </div>
              <div class="form-group">
                <app-custom-dropdown [options]="serviceAreas"
                                     [placeholder]="'Select an option'"
                                     [(ngModel)]="appointment.LocationID"
                                     [optionsText]="'ServiceAreaName'"
                                     [optionsValue]="'ID'">
                </app-custom-dropdown>
              </div>
            </div>
            <div class="row gap-20" *ngIf="appointment.IsEmployeeMeeting && appointment.Location">
              <div class="title align-center">
                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.5 10.9077C21.5015 10.6942 21.4584 10.4826 21.3737 10.2866C21.2889 10.0906 21.1643 9.91443 21.0077 9.76923L11.5 1L1.99234 9.76923C1.83577 9.91443 1.71113 10.0906 1.62637 10.2866C1.54162 10.4826 1.49859 10.6942 1.50004 10.9077V19.4615C1.50004 19.8695 1.66212 20.2609 1.95064 20.5494C2.23916 20.8378 2.63047 21 3.03849 21H19.9615C20.3695 21 20.7609 20.8378 21.0493 20.5494C21.338 20.2609 21.5 19.8695 21.5 19.4615V10.9077Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.5 20.9999V14.8461" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h2>Location:</h2>
              </div>
              <div class="form-group">
                <p>{{appointment.Location}}</p>
              </div>
            </div>
          </div>
          <div class="row justify-space-between">
            <div class="column gap-20">
              <div class="title">
                <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.5 21.2143C16.2734 21.2143 20.1429 17.3448 20.1429 12.5714C20.1429 7.79812 16.2734 3.92859 11.5 3.92859C6.72668 3.92859 2.85715 7.79812 2.85715 12.5714C2.85715 17.3448 6.72668 21.2143 11.5 21.2143Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M1.28571 3.92862C2.38929 2.64673 3.7214 1.58104 5.21428 0.785767" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M21.7143 3.92862C20.6107 2.64673 19.2786 1.58104 17.7857 0.785767" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.5 7.85718V12.5715H15.4286" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h2>Time</h2>
              </div>
              <div class="row justify-space-between gap-20">
                <div class="column" style="width: 260px;">
                  <div class="title align-center">
                    <span>From:</span>
                    <div class="form-group">
                      <app-custom-dropdown [options]="times"
                                           [placeholder]="'Select an option'"
                                           [(ngModel)]="appointment.StartTime"
                                           (ngModelChange)="onStartTimeChange()"
                                           [optionsText]="'Type'"
                                           [optionsValue]="'Type'"
                                           tabindex="4">
                      </app-custom-dropdown>
                    </div>
                  </div>
                </div>
                <div class="column" style="width: 260px;">
                  <div class="title align-center">
                    <span>To:</span>
                    <div class="form-group">
                      <app-custom-dropdown [options]="times"
                                           [placeholder]="'Select an option'"
                                           [(ngModel)]="appointment.EndTime"
                                           [optionsText]="'Type'"
                                           [optionsValue]="'Type'"
                                           tabindex="4"
                                           (ngModelChange)="calculateDuration()">
                      </app-custom-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!---->
          <ng-container *ngIf="!appointment.IsEmployeeMeeting">
            <hr />
            <div class="title">
              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.64284 7.85709C9.61528 7.85709 11.2143 6.2581 11.2143 4.28566C11.2143 2.31322 9.61528 0.714233 7.64284 0.714233C5.6704 0.714233 4.07141 2.31322 4.07141 4.28566C4.07141 6.2581 5.6704 7.85709 7.64284 7.85709Z" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.6428 17.857H1.21423V17.0826C1.22561 15.9937 1.51277 14.9255 2.0489 13.9777C2.58505 13.0299 3.35266 12.2335 4.28005 11.6628C5.20745 11.092 6.26436 10.7657 7.35206 10.7142C7.44903 10.7096 7.54598 10.7072 7.6428 10.707C7.73963 10.7072 7.83659 10.7096 7.93356 10.7142C9.02126 10.7657 10.0782 11.092 11.0056 11.6628C11.5389 11.9909 12.0193 12.3937 12.4333 12.8571" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19.7857 12.1428L14.0714 19.2857L11.2142 17.1428" stroke="#004D8B" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h3>Patient Details</h3>
            </div>
            <div class="row justify-space-between gap-20">
              <div class="column gap-20">
                <div class="row gap-10">
                  <p><span>Title: </span></p>
                  <p>{{appointment.PatientTitle}}</p>
                </div>
                <div class="row gap-10">
                  <p><span>Gender: </span></p>
                  <p>{{appointment.PatientGender}}</p>
                </div>
              </div>
              <div class="column gap-20">
                <div class="row gap-10">
                  <p><span>Patient Name: </span></p>
                  <p>{{appointment.PatientName}}</p>
                </div>
                <div class="row gap-10">
                  <p><span>Email Address: </span></p>
                  <p>{{appointment.PatientEmail}}</p>
                </div>
              </div>
              <div class="column gap-20">
                <div class="row gap-10">
                  <p><span>Patient Status:</span></p>
                  <p><strong>{{appointment.PatientStatus}}</strong></p>
                </div>
                <div class="row gap-10">
                  <p><span>Cellphone: </span></p>
                  <p>{{appointment.PatientCellphone}}</p>
                </div>
              </div>
            </div>
          </ng-container>
          <hr />
          <div class="title">
            <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15.2258 14.6772C15.521 14.3968 15.7561 14.0593 15.9169 13.6851C16.0775 13.311 16.1605 12.908 16.1605 12.5008C16.1605 12.0936 16.0775 11.6907 15.9169 11.3165C15.7561 10.9424 15.521 10.6048 15.2258 10.3244C14.6214 9.75073 13.8198 9.43091 12.9865 9.43091C12.1532 9.43091 11.3516 9.75073 10.7472 10.3244L8.50006 12.5715L6.25292 10.3244C5.64848 9.75073 4.84694 9.43091 4.01363 9.43091C3.1803 9.43091 2.37876 9.75073 1.77434 10.3244C1.47906 10.6048 1.24394 10.9424 1.08326 11.3165C0.922583 11.6907 0.839722 12.0936 0.839722 12.5008C0.839722 12.908 0.922583 13.311 1.08326 13.6851C1.24394 14.0593 1.47906 14.3968 1.77434 14.6772L8.50006 21.2143L15.2258 14.6772Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M8.50003 7.07148C10.2358 7.07148 11.6429 5.66438 11.6429 3.92862C11.6429 2.19287 10.2358 0.785767 8.50003 0.785767C6.76428 0.785767 5.35718 2.19287 5.35718 3.92862C5.35718 5.66438 6.76428 7.07148 8.50003 7.07148Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <h3>Services</h3>
          </div>
          <div class="row">
            <div class="title column gap-10">
              <h3>{{appointment.ServiceType}}</h3>
              <p>{{appointment.ServiceName}}</p>
            </div>
          </div>
          <ng-container *ngIf="!appointment.IsEmployeeMeeting">
            <hr />
            <div class="title">
              <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.9285 2.35718H15.2857C15.7024 2.35718 16.1022 2.52274 16.3968 2.81743C16.6915 3.11214 16.8571 3.51183 16.8571 3.92861V19.6429C16.8571 20.0596 16.6915 20.4594 16.3968 20.7541C16.1022 21.0487 15.7024 21.2143 15.2857 21.2143H2.71425C2.29748 21.2143 1.89778 21.0487 1.60308 20.7541C1.30839 20.4594 1.14282 20.0596 1.14282 19.6429V3.92861C1.14282 3.51183 1.30839 3.11214 1.60308 2.81743C1.89778 2.52274 2.29748 2.35718 2.71425 2.35718H5.07139" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M11.357 0.785645H6.64272C5.77485 0.785645 5.07129 1.4892 5.07129 2.35707V3.14279C5.07129 4.01066 5.77485 4.71422 6.64272 4.71422H11.357C12.2249 4.71422 12.9284 4.01066 12.9284 3.14279V2.35707C12.9284 1.4892 12.2249 0.785645 11.357 0.785645Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M7.9042 8.18701C7.53155 8.18701 7.22946 8.4891 7.22946 8.86177V10.7595H5.33172C4.95907 10.7595 4.65698 11.0616 4.65698 11.4343V13.6272C4.65698 13.9998 4.95907 14.3019 5.33172 14.3019H7.22946V16.1996C7.22946 16.5722 7.53155 16.8744 7.9042 16.8744H10.0971C10.4698 16.8744 10.7719 16.5722 10.7719 16.1996V14.3019H12.6696C13.0423 14.3019 13.3443 13.9999 13.3443 13.6272V11.4343C13.3443 11.0616 13.0423 10.7595 12.6696 10.7595H10.7719V8.86177C10.7719 8.4891 10.4698 8.18701 10.0971 8.18701H7.9042Z" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <h3>Patient Notes</h3>
            </div>
            <div class="detail-group">
              <input type="text" class="form-control" [(ngModel)]="appointment.AppointmentNotes" style=" width: 100%; height: 48px; padding: 10px;" />
            </div>
            <div *ngIf="showError == true" class="error-popup row">
              <h3 class="error-message">* {{erroMessage}}</h3>
            </div>
          </ng-container>
          <div class="row justify-end">
            <button class="custom-btn" (click)="UpdateAppointment()">Save</button>
          </div>
        </div>
      </div>
    <!--<div class="appointment-history">
      <div class="header">
        <h1>Appointment History</h1>
      </div>
      <div class="custom-table">
        <div class="details-row history-details" *ngFor="let apt of appointmentHistory">
          <div class="detail-group">
            <p><span>{{apt.date}}</span></p>
            <p>{{apt.activity}}</p>
          </div>
          <div class="detail-group">
            <p><span>{{apt.name}}</span></p>
          </div>
          <div class="detail-group">
            <p><span>{{apt.details}}</span></p>
            <p>{{apt.branch}}</p>
          </div>
          <div class="detail-group">
            <p><span>{{apt.result}}</span></p>
            <p>{{apt.result2}}</p>
          </div>
        </div>
      </div>
    </div>-->
    <!--<div class="header-btn" style="justify-content: end; padding-bottom: 20px;">
      <button class="btn" (click)="scrollToTop()">Back To Top</button>
    </div>-->
  </div>
</div>
</div>
